export const FILTER_TYPES = {
  AGENCE_TYPE: "agence-filter",
  MONTH_YEAR_TYPE: "month-year-filter",
  MARQUE_TYPE: "marque-filter",
  STATUS_TYPE: "status-filter",
};
